/** Modal da tela do chat e a escolha de pessoas (nova conversa, adicionar ao grupo). */
import { useEffect, useMemo, useState } from "react";

import { detalheDoOperador, pessoas as listarPessoas } from "../../services/chat";
import { Avatar, ICONE, Ic } from "./Icones";

export function Modal({ open, titulo, aoFechar, children }) {
  useEffect(() => {
    if (!open) return undefined;
    const h = (e) => { if (e.key === "Escape") { e.preventDefault(); aoFechar(); } };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, aoFechar]);
  if (!open) return null;
  return (
    <div className="pchat-modal-fundo" onClick={(e) => e.target === e.currentTarget && aoFechar()}>
      <div className="pchat-modal" role="dialog" aria-modal="true" aria-label={titulo}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <h3>{titulo}</h3>
          <button type="button" className="pchat-btn" style={{ width: 32, height: 32 }} aria-label="Fechar" onClick={aoFechar}><Ic d={ICONE.x} size={16} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function EscolhaDePessoas({ request, excluir, multiplas, aoConfirmar, rotulo }) {
  const [dados, setDados] = useState(null);
  const [busca, setBusca] = useState("");
  const [marcadas, setMarcadas] = useState(new Map());
  useEffect(() => { listarPessoas(request).then(setDados).catch(() => setDados({ usuarios: [], operadores: [] })); }, [request]);
  const lista = useMemo(() => {
    const todas = [
      ...((dados?.usuarios) || []).map((u) => ({ id: u.id, nome: u.nome, tipo: "usuario", detalhe: u.cargo || "usuário", foto_url: u.foto_url })),
      ...((dados?.operadores) || []).map((o) => ({ id: o.id, nome: o.nome, tipo: "operador", detalhe: detalheDoOperador(o) })),
    ];
    const termo = busca.trim().toLowerCase();
    return todas.filter((p) => !excluir?.has(p.id)).filter((p) => !termo || p.nome.toLowerCase().includes(termo)).sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));
  }, [dados, busca, excluir]);
  const alternar = (p) => {
    if (!multiplas) { aoConfirmar([p]); return; }
    setMarcadas((atual) => { const novo = new Map(atual); if (novo.has(p.id)) novo.delete(p.id); else novo.set(p.id, p); return novo; });
  };
  return (
    <div style={{ display: "grid", gap: 10 }}>
      <input className="pchat-busca" placeholder="Buscar pessoa" value={busca} onChange={(e) => setBusca(e.target.value)} aria-label="Buscar pessoa" autoFocus />
      <div className="pchat-pessoas">
        {!dados && <small>Carregando pessoas…</small>}
        {dados && lista.length === 0 && <small>Ninguém com esse nome.</small>}
        {lista.map((p) => (
          <button key={`${p.tipo}-${p.id}`} type="button" className={`pchat-pessoa ${marcadas.has(p.id) ? "marcada" : ""}`} onClick={() => alternar(p)}>
            <Avatar nome={p.nome} pequeno foto={p.foto_url} />
            <span className="meta"><b>{p.nome}</b><small>{p.detalhe}</small></span>
            {multiplas && <span aria-hidden="true">{marcadas.has(p.id) ? "☑" : "☐"}</span>}
          </button>
        ))}
      </div>
      {multiplas && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button type="button" className="pchat-btn enviar texto" disabled={marcadas.size === 0} onClick={() => aoConfirmar([...marcadas.values()])}>{rotulo}{marcadas.size > 0 ? ` (${marcadas.size})` : ""}</button>
        </div>
      )}
    </div>
  );
}
